import React from 'react';
import { Mail, HelpCircle, FileText, CheckCircle2 } from 'lucide-react';
import { APP_CONFIG } from '../config/appConfig';

export const ContactPage: React.FC = () => {
  return (
    <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8 py-10 space-y-8">
      <div>
        <h1 className="text-3xl sm:text-4xl font-black text-navy-950">
          Contact & Operations Inquiries
        </h1>
        <p className="text-base text-slate-600 mt-2 leading-relaxed">
          Technical communications, inquiries, and platform governance.
        </p>
      </div>

      <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
        <div className="bg-white border border-slate-200 rounded-2xl p-6 sm:p-8 space-y-4 shadow-xs">
          <div className="w-10 h-10 bg-blue-50 text-blue-600 rounded-xl flex items-center justify-center">
            <Mail className="w-5 h-5" />
          </div>
          <h2 className="text-lg font-bold text-navy-950">
            Technical & General Inquiries
          </h2>
          <p className="text-xs sm:text-sm text-slate-600 leading-relaxed">
            For technical feedback, data discrepancies, or general correspondence regarding SignalNear:
          </p>
          <div className="p-3 bg-slate-50 rounded-lg border border-slate-200 text-xs">
            <span className="text-slate-400 block mb-0.5">Contact Email:</span>
            <a href={`mailto:${APP_CONFIG.contact.email}`} className="font-mono font-semibold text-blue-600 hover:underline">
              {APP_CONFIG.contact.email}
            </a>
          </div>
          <p className="text-[11px] text-slate-500">
            Responses are typically provided within 2-3 business days.
          </p>
        </div>

        <div className="bg-white border border-slate-200 rounded-2xl p-6 sm:p-8 space-y-4 shadow-xs">
          <div className="w-10 h-10 bg-emerald-50 text-emerald-600 rounded-xl flex items-center justify-center">
            <HelpCircle className="w-5 h-5" />
          </div>
          <h2 className="text-lg font-bold text-navy-950">
            Emergency Situations Notice
          </h2>
          <p className="text-xs sm:text-sm text-slate-600 leading-relaxed">
            Please do <strong>NOT</strong> email this inbox to report an active local emergency or request rescue assistance.
          </p>
          <div className="p-3 bg-red-50 border border-red-200 rounded-lg text-xs text-red-900 font-medium">
            SignalNear operators cannot dispatch emergency personnel. If you are experiencing an emergency or immediate danger, call <strong>911</strong> immediately.
          </div>
        </div>
      </div>

      {/* Production Deployment Launch Checklist (for founder) */}
      <section className="bg-slate-50 border border-slate-200 rounded-2xl p-6 space-y-3">
        <h3 className="text-sm font-bold text-navy-950 flex items-center gap-2">
          <FileText className="w-4 h-4 text-blue-600" />
          <span>Launch Configuration Checklist for Production Deployment</span>
        </h3>
        <p className="text-xs text-slate-600">
          As part of the master blueprint guidelines, the following configuration items are documented for production customization when a custom domain or advertising account is activated:
        </p>
        <ul className="text-xs text-slate-700 space-y-1.5 list-disc list-inside">
          <li><strong>VITE_CONTACT_EMAIL:</strong> Set in your hosting environment variables if you prefer a dedicated custom domain email.</li>
          <li><strong>VITE_ADSENSE_CLIENT_ID:</strong> Set once approved by Google AdSense (e.g., <code className="bg-white px-1 border rounded">ca-pub-XXXXXXXXXXXXXXXX</code>).</li>
          <li><strong>ads.txt:</strong> Update with your authorized publisher line in <code className="bg-white px-1 border rounded">public/ads.txt</code> after AdSense approval.</li>
          <li><strong>VITE_AFFILIATES_ENABLED:</strong> Set to <code className="bg-white px-1 border rounded">true</code> only after signing an affiliate agreement with an emergency equipment distributor.</li>
        </ul>
      </section>
    </div>
  );
};

